import React, { useState, useCallback, memo } from 'react'
import InfiniteScroll from 'react-infinite-scroller'

import { Card, Loading } from 'components'
import { useFeedarticlesQuery } from 'graphql/__generated__/graphql'

const FeedArticlesList: React.FunctionComponent<{}> = memo(() => {
	const [deletedIds, setDeletedIds]: [string[], any] = useState([])
	const updateDeletedIds = useCallback(
		(id: string) => () => {
			setDeletedIds((deletedIds: string[]) => deletedIds.concat([id]))
		},
		[],
	)

	const { data, error, loading, fetchMore } = useFeedarticlesQuery({
		fetchPolicy: 'network-only',
		variables: {
			userid: null,
			companyslug: null,
			teamid: null,
			first: 2,
			after: null,
		},
	})
	if (loading) {
		return (
			<div style={{ flexGrow: 1, display: 'flex' }}>
				<Loading size={48} />
			</div>
		)
	}
	if (error) {
		return <div>Error! {error.message}</div>
	}

	// TODO -> replace 'any' type
	const articles = data
		? data?.feedArticles?.edges?.map(edge => {
				return edge?.node
		  })
		: []
	const hasNextPage = data ? data?.feedArticles?.pageInfo?.hasNextPage : false

	// implement InfiniteScroll
	return !loading ? (
		<section
			style={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}
		>
			<InfiniteScroll
				pageStart={0}
				threshold={10}
				loadMore={() => {
					return fetchMore({
						variables: {
							after: data?.feedArticles?.edges[
								data.feedArticles.edges.length - 1
							]?.cursor,
						},
						updateQuery: (
							previousQueryResult,
							{ fetchMoreResult },
						) => {
							// Ensure fetchMoreResult exists and has feedarticles
							if (
								!fetchMoreResult ||
								!fetchMoreResult.feedArticles
							) {
								return previousQueryResult
							}

							const { edges: newEdges, pageInfo } =
								fetchMoreResult.feedArticles

							return newEdges.length > 0
								? {
										feedArticles: {
											__typename:
												previousQueryResult
													?.feedArticles?.__typename, // Keep __typename consistent
											edges: [
												...(previousQueryResult
													.feedArticles?.edges || []), // Ensure previous edges exist
												...newEdges,
											],
											pageInfo,
										},
								  }
								: previousQueryResult
						},
					})
				}}
				hasMore={hasNextPage}
				loader={
					<div
						style={{ flexGrow: 1, display: 'flex' }}
						key={'loading'}
					>
						<Loading size={48} />
					</div>
				}
				useWindow={true}
			>
				{articles
					?.filter(
						item =>
							item &&
							item.id &&
							deletedIds.indexOf(item.id) === -1,
					)
					?.map(article => {
						if (
							article?.activeArticleTagCollection?.edges &&
							article?.activeArticleTagCollection?.edges.length >
								0
						)
							console.log(
								article?.activeArticleTagCollection?.edges.map(
									tagEdge => ({
										...tagEdge.node,
										tag: {
											...tagEdge.node.articleTag,
										},
									}),
								),
							)
						return (
							<Card
								article={{
									...article,
									// tags: [], // TO DO Rares
									tags:
										article.activeArticleTagCollection?.edges.map(
											tagEdge => ({
												id: tagEdge.node.id,
												votes: parseInt(
													tagEdge.node.votes?.toString() ??
														'0',
												),
												title:
													tagEdge.node.articleTag
														?.title ?? '',
												tag: {
													id:
														tagEdge.node.articleTag
															?.id ?? '',
													title:
														tagEdge.node.articleTag
															?.title ?? '',
												},
											}),
										) ?? [],
								}}
								key={article.id}
								refetch={updateDeletedIds(article.id)}
							/>
						)
					})}
			</InfiniteScroll>
		</section>
	) : (
		<div style={{ flexGrow: 1, display: 'flex' }}>
			<Loading size={48} />
		</div>
	)
})

export default FeedArticlesList
